import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@/icons';
import './IconExportButton.css';

interface IconExportButtonProps {
  onClick: () => void;
  title?: string;
  disabled?: boolean;
  className?: string;
}

const IconExportButton: React.FC<IconExportButtonProps> = ({
  onClick,
  title,
  disabled = false,
  className = '',
}) => {
  return (
    <button
      className={`icon-export-button ${className}`}
      onClick={onClick}
      title={title}
      disabled={disabled}
    >
      <FontAwesomeIcon icon={faFileExcel} />
    </button>
  );
};

export default IconExportButton;
